export default __webpack_public_path__ + "207de33b63cd284f73d5144e4f769a6c.png";